import { Globals } from "../CoreApp/Globals";
export function setupCanvas(canvas, ref) {
  var parent = canvas;
  if (ref) parent = ref;
  var ctx = canvas.getContext("2d");
  var devicePixelRatio = window.devicePixelRatio || 1;

  var newWidth = parent.width;
  var newHeight = parent.height;

  canvas.width = Math.floor(newWidth * devicePixelRatio); // canvas scale up by device pixel ratio
  canvas.height = Math.floor(newHeight * devicePixelRatio); // canvas scale up by device pixel ratio

  canvas.style.width = newWidth + "px"; // keep
  canvas.style.height = newHeight + "px"; // style scale down by same scale value

  // for sprites scaled up to retina resolution
  ctx.mozImageSmoothingEnabled = false;
  ctx.imageSmoothingEnabled = false;
  Globals._dpr = devicePixelRatio;

  return canvas;
}
